import playerReducer, { INITIAL_STATE } from './player'
import type { PlayerState } from './player.types'

export { PlayerState, INITIAL_STATE }

export default playerReducer
